
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 5C6.773 5 3.621 6.324 3.621 6.324L3 6.578v20.387l.031-.016L3 27h11.277c.348.594.985 1 1.723 1 .738 0 1.375-.406 1.723-1H29l-.031-.05.031.015V6.578l-.621-.254S25.227 5 22 5c-2.918 0-5.48.988-6 1.195C15.48 5.988 12.918 5 10 5zm0 2c1.938 0 4.004.617 5 .953V24.07c-1.113-.363-2.95-.847-5-.847-2.102 0-3.813.472-5 .863V7.976C5.762 7.7 7.793 7 10 7zm12 0c2.207 0 4.238.7 5 .977v16.109c-1.188-.39-2.898-.863-5-.863-2.05 0-3.887.484-5 .847V7.953C17.996 7.617 20.063 7 22 7zm-1 3v1.04c-1.125.187-2 1.17-2 2.343v1h.285c.192.332.469.613.824.789L23 16.617a.372.372 0 01-.383.383h-1.234a.37.37 0 01-.383-.383V16h-2v.617c0 1.172.875 2.156 2 2.344V20h2v-1.043c.719-.14 1.246-.684 1.582-1.34H25v-1a2.01 2.01 0 00-1.105-1.789L21 13.378a.37.37 0 01.383-.378h1.234a.37.37 0 01.383.383V14h2v-.617c0-1.172-.875-2.156-2-2.344V10z"}})])
          )
        }
      }
    